<style lang="scss">
  @use "../../../../../assets/css/global.scss" as *;
  @use "../../../../../assets/css/_colors.scss" as *;
  @use "../Components/TrainingHubMixins.scss" as *;

  .task-content {
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: start;
    gap: 0.5rem 1rem;
    padding: 0 1rem;
    margin-right: 2rem;
    overflow: hidden;

    .task-icon-spacer {
      width: 2.5rem;
      height: 2.5rem;
    }

    max-height: 0;
    &.transitions {
      transition: max-height 0.3s ease-out;
    }
    &.expanded {
      max-height: 550px;
      &.transitions {
        transition: max-height 0.5s ease-in;
      }
    }

    .video-task-layout {
      display: flex;
      gap: 2rem;
      align-items: center;
      margin-bottom: 1rem;

      @media (max-width: 1600px) {
        display: grid;
        gap: 1rem;
      }
    }

    .task-description {
      color: $text-gray;
      font-size: 0.9rem;

      @include training-hub-locked();
    }

    .status-message {
      background-color: $light-blue;
      border-radius: 0.5rem;
      padding: 0.75rem 1rem;
      margin: 0 auto 1rem 0;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-size: 0.8rem;
      color: $primary-color;
      font-weight: 700;

      i {
        color: $blue;
      }

      &.completed {
        background-color: $light-green;
        color: $green;

        i {
          color: $green;
        }
      }

      &.locked-order {
        order: -1;
      }
    }

    .task-actions {
      display: grid;
      grid-template-columns: auto auto;
      gap: 1rem;
      justify-content: start;
    }

    .task-details-wrapper {
      display: flex;
      flex-direction: column;
      margin-bottom: 1.5rem;
    }
  }
</style>

<script>
  import ActionButton from "../Components/ActionButton.svelte";
  import { interactiveTasks } from "../stores";
  import TaskVideo from "./TaskVideo.svelte";

  export let task;

  $: expanded = $interactiveTasks.selectedTaskId === task.taskId;
  $: locked = task.status === "locked";
  $: completed = task.status === "completed";
  $: transitions = $interactiveTasks.lastUserAction === "setTask";
</script>

<div class="task-content" class:expanded class:transitions>
  {#if task.taskType === "Video"}
    <div class="task-icon-spacer"></div>
    <div class="video-task-layout">
      <TaskVideo {task} />
    </div>
  {:else}
    <div class="task-icon-spacer"></div>
    <div class="task-details-wrapper">
      <p class="task-description" class:completed class:locked>
        {task.description}
      </p>
      {#if task.statusMessage}
        <div class="status-message" class:completed class:locked-order={locked}>
          <i
            class={task.status === "completed"
              ? "fa-solid fa-circle-check"
              : "fa-solid fa-circle-info"}
          ></i>
          {task.statusMessage.text}
        </div>
      {/if}
      <div class="task-actions">
        <ActionButton
          class="primary {task.status}"
          {...task.cta.primary.attributes}
        >
          {task.cta.primary.text}
        </ActionButton>
        {#if task.cta.secondary}
          <ActionButton
            class="secondary {task.status}"
            {...task.cta.secondary.attributes}
          >
            {task.cta.secondary.text}
          </ActionButton>
        {/if}
      </div>
    </div>
  {/if}
</div>
